/* loaded by smart-asset */
export default require("./assets/black-pallet-loaded.i.svg")